import React, { useState, useRef, useEffect } from 'react';
import { motion } from 'framer-motion';
import './WiggaPaper.css';

const WiggaPaper = () => {
  const [activeSection, setActiveSection] = useState(0);
  const [highlightedText, setHighlightedText] = useState(null);
  const paperRef = useRef(null);
  
  const handleSectionClick = (index) => {
    setActiveSection(index);
    // Scroll to section
    const sectionElements = document.querySelectorAll('.paper-section');
    if (sectionElements[index]) {
      sectionElements[index].scrollIntoView({ behavior: 'smooth' });
    }
  };
  
  const handleHighlight = (index) => {
    setHighlightedText(index);
    
    // Auto-clear highlight after 2 seconds
    setTimeout(() => {
      setHighlightedText(null);
    }, 2000);
  };
  
  // Paper sections
  const paperSections = [
    {
      title: "1. Abstract",
      content: `WiggaChain represents a paradigm shift in distributed ledger technology, fundamentally redefining what it means to be "in the blockchain game." Unlike traditional blockchain protocols that wastefully solve arbitrary mathematical problems to achieve consensus, WiggaChain introduces a revolutionary "Proof-of-Wigga" mechanism that measures a participant's ability to properly identify whether various scenarios are, in fact, "bussin'" or "straight cap." This paper outlines the groundbreaking technical innovations behind WiggaChain, a system designed specifically for wiggaz who recognize real value when they see it.`
    },
    {
      title: "2. Introduction",
      content: `The current blockchain landscape is dominated by projects built by nerds who have never seen the inside of a club. These systems fail to account for real-world applications that matter to the average wigga, such as flexing on haters, identifying quality drip, and maintaining proper clout metrics. WiggaChain addresses these critical gaps in the market with a suite of proprietary technologies including FlexConsensus™, DrippyCoin™ integration, and our patented NoSnitchTechnology™ that ensures your financial moves stay between you and your day ones.`
    },
    {
      title: "3. Tokenomics",
      content: `$WIGGA token distribution follows the scientifically proven "All Gas No Brakes" allocation model:

- 40% - Initial Degen Offering (first 72 hours)
- 20% - Founder bag (for lambos and unnecessary iced-out accessories)
- 15% - Marketing (paying influencers to pretend they understand blockchain)
- 10% - Development (copying Solana's code and changing variable names)
- 10% - Community rewards (for meme contests and who can talk the most shit)
- 5% - Rugpull prevention fund (we'll explain this one later)`
    },
    {
      title: "4. Proof-of-Wigga Consensus",
      content: `The revolutionary Proof-of-Wigga (PoW) consensus mechanism represents the first algorithm that combines blockchain verification with cultural authentication. Nodes gain validation rights by correctly identifying:

1. Whether a proposed price action is "bussin'" or "straight cap"
2. If a particular NFT has "got that DAWG in it"
3. Whether a DeFi protocol is "low-key fire" or "mid AF"
4. The correct usage of "no cap" in a sentence
5. If someone is a "paper-handed bitch" or "diamond-handed chad"

Nodes that consistently demonstrate superior judgment in these categories earn higher validation privileges, creating a self-reinforcing system that ensures only the most culturally attuned wiggaz secure the network.`
    },
    {
      title: "5. Technical Architecture",
      content: `WiggaChain's technical stack leverages cutting-edge technologies including but not limited to:

- YOLO-Finality: Our patented transaction commitment protocol that makes decisions faster by not checking for errors
- SideEye Detection Algorithm: Automatically identifies and blocks suspicious transactions using complex "vibe check" calculations
- FlexVM: A virtual machine optimized for processing flexes and clout calculations
- Rich-Get-Richer Scalability Solution: The more tokens you hold, the faster your transactions process (we call this innovation "reality")

This architecture enables WiggaChain to process an unprecedented 69,420 transactions per second, making it the fastest chain that will definitely exist someday.`
    },
    {
      title: "6. NoSnitchTechnology™",
      content: `WiggaChain's groundbreaking NoSnitchTechnology™ ensures complete transaction privacy, making it impossible for authorities, exes, parents, or opps to track your financial activities. Unlike inferior "privacy coins" that rely on complex mathematics, NoSnitchTechnology™ employs a sophisticated "Bro Code" protocol where all network participants agree to "just not tell nobody" about what they see.

Our system is further secured by the "Snitches Get Stitches" failsafe mechanism, which automatically identifies and ejects any node attempting to compromise the network's omertà.`
    },
    {
      title: "7. Strategic Roadmap",
      content: `Q3 2025: "The Launch" - Initial token distribution, immediate listing on sketchy exchanges
Q4 2025: "The Pump" - Aggressive marketing push, celebrity endorsements from rappers who don't understand the product
Q1 2026: "The Flex" - Launch of WiggaSwap DEX, NFT marketplace for digital grills and chains
Q2 2026: "The Dip" - Team addresses "temporary market correction" while quietly selling tokens
Q3 2026: "The Rebrand" - Pivot to new market segment when original concept fails
Q4 2026: "The Phoenix" - Resurrection as WiggaChain 2.0 with exact same features but new logo
Q1 2027: "The Moon" - Integration with other chains that actually work`
    },
    {
      title: "8. Conclusion",
      content: `WiggaChain represents not just a technological innovation but a cultural movement. We envision a future where blockchain technology is accessible to everyone, regardless of whether they understand what a hash function is or why anyone would need one.

In the tradition of great innovators who came before us, we stand on the shoulders of giants—specifically, the giants whose code we copied from GitHub. The future is bright, the tokenomics are definitely sustainable, and this is absolutely not financial advice.

As we always say at WiggaChain: "Fortune favors the brave, but generational wealth favors those who convince others to provide exit liquidity."`
    }
  ];
  
  const highlightableTexts = [
    { section: 1, text: "nerds who have never seen the inside of a club" },
    { section: 2, text: "All Gas No Brakes" },
    { section: 2, text: "Founder bag (for lambos and unnecessary iced-out accessories)" },
    { section: 2, text: "copying Solana's code and changing variable names" },
    { section: 3, text: "got that DAWG in it" },
    { section: 3, text: "paper-handed bitch" },
    { section: 4, text: "YOLO-Finality" },
    { section: 5, text: "just not tell nobody" },
    { section: 6, text: "Q2 2026: \"The Dip\" - Team addresses \"temporary market correction\" while quietly selling tokens" },
    { section: 7, text: "generational wealth favors those who convince others to provide exit liquidity" }
  ];

  return (
    <section className="wiggapaper-section">
      <div className="wiggapaper-background">
        <div className="paper-grid"></div>
        <div className="glow-orb paper-orb-1"></div>
        <div className="glow-orb paper-orb-2"></div>
      </div>
      
      <div className="wiggapaper-container">
        <motion.div 
          className="paper-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="paper-title">The <span className="gradient-text">WiggaPaper</span></h1>
          <div className="paper-subtitle">Official Technical Documentation</div>
          <div className="paper-authors">
            By Dr. Diamond Handz, PhD in Applied FOMO & Prof. Rug Pullsington, Chair of Vaporware Economics
          </div>
          <div className="paper-date">v4.20.69 | Last Updated: When We Felt Like It</div>
        </motion.div>
        
        <div className="paper-content">
          <div className="paper-navigation">
            <h3>Table of Contents</h3>
            <ul className="navigation-list">
              {paperSections.map((section, index) => (
                <li 
                  key={index}
                  className={activeSection === index ? 'active' : ''}
                  onClick={() => handleSectionClick(index)}
                >
                  {section.title}
                </li>
              ))}
            </ul>
            
            <div className="paper-certifications">
              <div className="certification">
                <span className="certification-icon">🔥</span>
                <span className="certification-text">Certified Gas</span>
              </div>
              <div className="certification">
                <span className="certification-icon">💯</span>
                <span className="certification-text">No Cap Technology</span>
              </div>
              <div className="certification">
                <span className="certification-icon">🧠</span>
                <span className="certification-text">Big Brain Verified</span>
              </div>
            </div>
          </div>
          
          <div className="paper-main" ref={paperRef}>
            {paperSections.map((section, index) => (
              <div key={index} className="paper-section">
                <h2 className="section-title">{section.title}</h2>
                <div className="section-content">
                  {section.title === "3. Tokenomics" ? (
                    <div dangerouslySetInnerHTML={{ __html: section.content.replace(/\n/g, '<br />') }} />
                  ) : section.title === "7. Strategic Roadmap" ? (
                    <div dangerouslySetInnerHTML={{ __html: section.content.replace(/\n/g, '<br />') }} />
                  ) : (
                    <p>{section.content}</p>
                  )}
                </div>
                
                {index === paperSections.length - 1 && (
                  <div className="paper-signature">
                    <div className="signature-block">
                      <div className="signature-image"></div>
                      <div className="signature-name">Dr. Diamond Handz</div>
                      <div className="signature-title">Chief Vision Officer</div>
                    </div>
                    <div className="signature-block">
                      <div className="signature-image"></div>
                      <div className="signature-name">Prof. Rug Pullsington</div>
                      <div className="signature-title">Exit Strategy Director</div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
        
        <div className="paper-highlight-container">
          {highlightableTexts.map((item, index) => (
            <motion.div 
              key={index}
              className={`highlight-item ${highlightedText === index ? 'active' : ''}`}
              whileHover={{ scale: 1.05 }}
              onClick={() => handleHighlight(index)}
            >
              <span className="highlight-icon">💀</span>
              <span className="highlight-text">{item.text}</span>
            </motion.div>
          ))}
        </div>
        
        <div className="paper-cta">
          <h3 className="cta-title">Ready to join the financial revolution?</h3>
          <p className="cta-text">Get in now before we explain why the price temporarily crashed 98%</p>
          <button className="primary-button">
            <span>Buy $WIGGA Tokens</span>
            <span className="button-glow"></span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default WiggaPaper;